import { Components, Theme } from '@mui/material/styles';

export default function MuiPickersOutlinedInput(theme: Theme): Components['MuiPickersOutlinedInput'] {
  return {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.sandTint.main,
        border: `1px solid ${theme.palette.sandShade3.main}`,
        borderRadius: '4px',
        paddingLeft: '12px',
        '&.Mui-focused': {
          borderColor: theme.palette.ocean.main,
        },
        '&.Mui-error': {
          borderColor: theme.palette.error.main,
        },
        '&.Mui-disabled': {
          backgroundColor: `${theme.palette.sandTint.main}80`,
          borderColor: `${theme.palette.sandShade3.main}80`,
        },
      },
      input: {
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingRight: '12px',
        paddingLeft: 0,
        '&.Mui-disabled': {
          WebkitTextFillColor: 'revert',
          color: theme.palette.taigaTint1.main,
        },
      },
      notchedOutline: {
        display: 'none',
      },
    },
  };
}
